export enum FunctionalAnalysesImportanceEnum {
  ExtremelyImportant = 1,
  VeryImportant,
  ModeratelyImportant,
  NotImportant,
}
